import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import TelecallerHeader from './TelecallerHeader'
import { sidebarContext } from '../../App'

export default function TelecallerDonationEnquiry() {
    const { id } = useParams()
    const token = localStorage.getItem('token')
    const navigate = useNavigate()
    const [enquiries, setEnquiries] = useState([])
    const {setHS} = useContext(sidebarContext)

    useEffect(() => {
      setHS(0)
    },[setHS])

    const fetchDonationEnquiry = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_donation_enquiry/`, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('enquiries enquiry res')

            if(res.status === 200){
                setEnquiries(res.data.data)
            }else{
                toast.error('Failed to fetch donation enquiries')
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to create Staff'

            toast.error(message)
        }
    }

    useEffect(() => {
        fetchDonationEnquiry()
    },[token])
    console.log('Donation Enquiries in Telecaller res:', enquiries)

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <TelecallerHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL Donation Enquiries
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all registered Donation Enquiries assigned to {enquiries.donar_name}.
        </p>
      </div>

      <div className='overflow-x-auto overflow-y-auto max-h-[70vh]'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='text-center border-b border-slate-300'>
              <th className='px-3 py-2 whitespace-nowrap'>No</th>
              <th className='px-3 py-2 whitespace-nowrap'>Name</th>
              <th className='px-3 py-2 whitespace-nowrap'>Email</th>
              <th className='px-3 py-2 whitespace-nowrap'>Phone</th>
              <th className='px-3 py-2 whitespace-nowrap'>Subject</th>
              <th className='px-3 py-2 whitespace-nowrap'>Message</th>
            </tr>
          </thead>

          <tbody>
            {enquiries.length > 0 ? (
              enquiries.map((item, index) => (
                <tr
                  key={item.id}
                  className='text-center border-b border-b-slate-300 cursor-pointer'
                >
                  <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.name}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.email}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.phone}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.subject}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.message}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className='text-center py-6'
                >
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
